<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'components.clinical-onboarding.clinician-detail.edit-data-title' | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!saving ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (saving) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<!-- Ridisegno UI in tab (feedback utente: Dettagli/Dati contrattuali/Documenti/
     Storico): nome/cognome/email si modificano ora direttamente nella tab
     "Dettagli" del pannello di dettaglio, non piu' qui - questa modale resta
     scoperta di anagrafica, solo dati contrattuali. name/last_name/email restano
     comunque nel form (sempre obbligatori lato server), solo senza un campo
     visibile: il valore inviato e' semplicemente quello gia' presente. -->
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container my-4">
    <h6 class="field-group-label">{{ 'components.clinical-onboarding.wizard.step-employer' | translate }}</h6>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'components.clinical-onboarding.wizard.field-title' | translate }}</mat-label>
          <input matInput formControlName="title" maxlength="50">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'components.clinical-onboarding.wizard.field-employer-type' | translate }}</mat-label>
          <mat-select formControlName="employer_type">
            <mat-option [value]="EmployerType.PUBLIC">{{ 'components.clinical-onboarding.employer-type.public' | translate }}</mat-option>
            <mat-option [value]="EmployerType.PRIVATE">{{ 'components.clinical-onboarding.employer-type.private' | translate }}</mat-option>
            <mat-option [value]="EmployerType.NONE">{{ 'components.clinical-onboarding.employer-type.none' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    @if (isEmployerPublic) {
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.clinical-onboarding.wizard.field-employer-name' | translate }}</mat-label>
            <input matInput formControlName="employer_name" maxlength="255">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.clinical-onboarding.clinician-detail.field-pa-authorization' | translate }}</mat-label>
            <mat-select formControlName="pa_authorization_status">
              <mat-option [value]="PaAuthorizationStatus.NOT_REQUIRED">{{ 'components.clinical-onboarding.pa-authorization-status.not-required' | translate }}</mat-option>
              <mat-option [value]="PaAuthorizationStatus.REQUIRED_PENDING">{{ 'components.clinical-onboarding.pa-authorization-status.required-pending' | translate }}</mat-option>
              <mat-option [value]="PaAuthorizationStatus.REQUIRED_RECEIVED">{{ 'components.clinical-onboarding.pa-authorization-status.required-received' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }

    <h6 class="field-group-label mt-3">{{ 'components.clinical-onboarding.wizard.step-fiscal' | translate }}</h6>
    <div class="row">
      <div class="col-md-6">
        <!-- Feedback utente: "il testo si sovrappone" - con subscriptSizing di
             default (fixed) l'area sotto il campo resta alta una riga sola: un
             hint piu' lungo (come questo) sfora e si sovrappone alla riga
             successiva invece di spingerla in basso. -->
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>{{ 'components.clinical-onboarding.wizard.field-iban' | translate }}</mat-label>
          <input matInput formControlName="iban" placeholder="IT00X0000000000000000000000">
          @if (hasIban) {
            <mat-hint>{{ 'components.clinical-onboarding.wizard.locked-hint' | translate }}</mat-hint>
          }
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>{{ 'components.clinical-onboarding.wizard.field-tax-code' | translate }}</mat-label>
          <input matInput formControlName="tax_code" maxlength="16">
          @if (hasTaxCode) {
            <mat-hint>{{ 'components.clinical-onboarding.wizard.locked-hint' | translate }}</mat-hint>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'components.clinical-onboarding.wizard.field-fiscal-regime' | translate }}</mat-label>
          <mat-select formControlName="fiscal_regime">
            <mat-option [value]="FiscalRegime.OCCASIONAL_SIMPLE">{{ 'components.clinical-onboarding.fiscal-regime.occasional-simple' | translate }}</mat-option>
            <mat-option [value]="FiscalRegime.INPS_SEPARATE_MANAGEMENT">{{ 'components.clinical-onboarding.fiscal-regime.inps-separate-management' | translate }}</mat-option>
            <mat-option [value]="FiscalRegime.VAT_NUMBER">{{ 'components.clinical-onboarding.fiscal-regime.vat-number' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'components.clinical-onboarding.clinician-detail.field-gross-amount' | translate }}</mat-label>
          <input matInput type="number" min="0" step="0.01" formControlName="gross_amount">
          <span matTextSuffix>&nbsp;EUR</span>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="buttons-container container mb-3 d-flex justify-content-center">
    <button mat-stroked-button class="text-dark-purple border-purple mr-2" type="button" [disabled]="saving" (click)="closeDialogue()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="saving">{{ 'generic.buttons.save' | translate }}</button>
  </div>
</form>
